import React from "react";

import Chatbot from "../components/Chatbot";
import DemoMedia from "../components/DemoMedia";
import SEO from "../components/SEO";

const Demo = () => {
  return (
    <>
      <SEO
        title="Demo - OpenMind"
        description="See OM1 in action! OM1 powers the future of intelligent machines."
        canonical="https://openmind.org/demo"
      />
      <section className="overflow-hidden relative mx-auto my-0 w-full min-h-screen bg-white">
        <div className="block sm:hidden">
          <DemoMedia />
        </div>
        <div className="flex relative gap-20 px-11 pt-44 pb-0 max-md:flex-col max-md:gap-10 max-md:px-8 max-md:pt-32 max-md:pb-0 max-sm:pt-6 max-sm:px-6 max-sm:pb-0">
          <h1 className="relative z-10 mb-10 text-5xl tracking-tighter leading-[108%] lg:max-w-[40%] sm:max-w-[60%] text-stone-900 max-md:text-[40px] max-sm:text-[24px] max-md:mb-10 max-sm:leading-[1.15] max-sm:w-[80%] max-sm:tracking-tighter">
            OM1 powers the future of intelligent machines.
          </h1>
        </div>

        <div className="flex justify-end m-30 max-md:m-20 max-md:pl-12 max-sm:pl-8 max-sm:my-0 max-sm:w-[80%]">
          <div className="relative text-2xl leading-[108%] max-w-[40%] font-creato max-md:max-w-full max-md:text-[18px] mr-[10%]">
            <p>
              Robots have stepped out of science fiction and into real life —
              working alongside us in classrooms, factories, homes, and labs,
              guided by open systems that let them see, move, and think.
            </p>
          </div>
        </div>
        <div className="hidden sm:block">
          <DemoMedia />
        </div>
        <Chatbot />
      </section>
    </>
  );
};

export default Demo;
